export default "/images/e3dbb7666b0d6f2835a7f55e93d96f9c.png";